/**
 * Admin API service for admin panel operations
 */
import { apiClient } from '../apiClient';

class AdminApiService {
  // User management methods
  async getUsers(page = 1, limit = 20, search = '') {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) {
      params.append('search', search);
    }

    return await apiClient.request(`/admin/users?${params}`);
  }

  async getUserDetail(userId) {
    return await apiClient.request(`/admin/users/${userId}`);
  }

  async updateUser(userId, userData) {
    return await apiClient.request(`/admin/users/${userId}`, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });
  }

  async bulkUpdateUsers(userIds, updates) {
    return await apiClient.request('/admin/users/bulk', {
      method: 'PUT',
      body: JSON.stringify({
        user_ids: userIds,
        updates: updates,
      }),
    });
  }

  // Task management methods
  async getTasks(page = 1, limit = 20) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    return await apiClient.request(`/admin/tasks?${params}`);
  }

  async createTask(taskData) {
    return await apiClient.request('/admin/tasks', {
      method: 'POST',
      body: JSON.stringify(taskData),
    });
  }

  async updateTask(taskId, taskData) {
    return await apiClient.request(`/admin/tasks/${taskId}`, {
      method: 'PUT',
      body: JSON.stringify(taskData),
    });
  }

  // Audit logs methods
  async getAuditLogs(filters = {}) {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value.toString());
      }
    });

    return await apiClient.request(`/admin/audit-logs?${params}`);
  }

  // Helper method to check if current user is admin
  async isCurrentUserAdmin() {
    try {
      // Try to access admin users endpoint
      await this.getUsers(1, 1);
      return true;
    } catch (error) {
      if (error.message.includes('403') || error.message.includes('Forbidden')) {
        return false;
      }
      throw error;
    }
  }
}

export const adminApi = new AdminApiService();